import { render, staticRenderFns } from "./popularPetitionList.vue?vue&type=template&id=66f6ce95&scoped=true&"
import script from "./popularPetitionList.vue?vue&type=script&lang=js&"
export * from "./popularPetitionList.vue?vue&type=script&lang=js&"
import style0 from "./popularPetitionList.vue?vue&type=style&index=0&id=66f6ce95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6ce95",
  null
  
)

export default component.exports